import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-lg text-textPrimary" }
const _hoisted_2 = { class: "w-full flex justify-center mb-6 sm:mb-8 px-2 sm:px-0" }
const _hoisted_3 = { class: "text-center text-[#16161D] text-[15px] sm:text-[16px] font-normal leading-[22px] sm:leading-[24px] tracking-[0.08px]" }
const _hoisted_4 = { class: "flex items-center gap-3 sm:gap-6 w-full" }

import ModalVue from '@/components/designSystem/modals/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDeleteRoleModal',
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean },
    title: {},
    description: {},
    informational: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;





const handleCancel = (): void => {
  emit('update:modelValue', false)
  emit('cancel')
}

const handleConfirm = (): void => {
  emit('confirm')
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "show-close-button": true,
    "has-header-border": false,
    "has-footer-border": false,
    "max-width": "!w-[92vw] sm:!w-[529px] !max-w-[529px]",
    "data-testid": "confirm-delete-role-modal",
    onClose: handleCancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(props.title), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (props.informational)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "flat",
              class: "!flex-1 !h-12 !rounded !bg-[#2F7F91] !text-white !font-bold !normal-case !px-2 sm:!px-4",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Entendi ")
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_v_btn, {
                variant: "flat",
                disabled: _ctx.loading,
                class: "!flex-1 !h-12 !rounded !bg-[#2F7F91] !text-white !font-bold !normal-case !px-2 sm:!px-4",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                variant: "outlined",
                loading: _ctx.loading,
                class: "!flex-1 !h-12 !rounded !border-2 !border-[#DA1E28] !bg-white !text-[#DA1E28] !font-bold !normal-case !px-2 sm:!px-4",
                onClick: handleConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }, 8, ["loading"])
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(props.description), 1)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})